import Background from 'umg-ember-backend/components/page-builder/options/form/section/background';
import CustomOptions from 'umg-ember-backend/components/page-builder/options/form/section/custom-options';
import DisplayOptions from 'umg-ember-backend/components/page-builder/options/form/section/display-options';
import Height from 'umg-ember-backend/components/page-builder/options/form/section/height';
import Selectors from 'umg-ember-backend/components/page-builder/options/form/section/selectors';

<template>
  <DisplayOptions
    @form={{@form}}
    @elementConfig={{@elementConfig}}
    @mlp={{@mlp}}
  />
  <Height @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <Background @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <@form.fieldset
    @titleKey='button'
    @isClosed={{true}}
    @showSelectedAttributesIndicator={{true}}
    as |fieldset|
  >
    <fieldset.field @property='options.buttonBackgroundColor' @type='color' />

    <fieldset.field @property='options.buttonFontColor' @type='color' />

    <fieldset.field @property='options.buttonBorderWidth' @type='number' />

    <fieldset.field @property='options.buttonBorderColor' @type='color' />

    <fieldset.field @property='options.buttonBorderRadius' @type='number' />
  </@form.fieldset>
  <Selectors @form={{@form}} @elementConfig={{@elementConfig}} @mlp={{@mlp}} />
  <CustomOptions
    @form={{@form}}
    @elementConfig={{@elementConfig}}
    @mlp={{@mlp}}
  />
</template>
